import { render, staticRenderFns } from "./ChapterDocuments.vue?vue&type=template&id=c5b915b2"
import script from "./ChapterDocuments.vue?vue&type=script&lang=js"
export * from "./ChapterDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports